import UIStateContext from "contexts/UIStateContext";
import { useContext } from "react";

export const SLIDE_OUT_MODES = {
  FILTER: "filter",
  HIDDEN: "none",
  WORK_ORDER_DETAILS: "work order details",
};

export default function useSlideOutState() {
  const {
    state: { slideOutState },
    setState,
  } = useContext(UIStateContext);

  const openFilterSidebar = () =>
    setState({ slideOutState: { mode: SLIDE_OUT_MODES.FILTER, workOrderCode: null, workOrderId: null } });
  const openWorkOrderDetails = (workOrderId) =>
    setState({
      slideOutState: {
        mode: SLIDE_OUT_MODES.WORK_ORDER_DETAILS,
        workOrderCode: workOrderId === slideOutState.workOrderId ? slideOutState.workOrderCode : null,
        workOrderId,
      },
    });
  const closeSlideOut = () =>
    setState({ slideOutState: { mode: SLIDE_OUT_MODES.HIDDEN, workOrderCode: null, workOrderId: null } });
  const isOpen = () => slideOutState.mode !== SLIDE_OUT_MODES.HIDDEN;
  const isFilterMode = () => slideOutState.mode === SLIDE_OUT_MODES.FILTER;
  const isWorkOrderMode = () => slideOutState.mode === SLIDE_OUT_MODES.WORK_ORDER_DETAILS;
  const setWorkOrderCode = (workOrderCode) =>
    setState({
      slideOutState: {
        mode: SLIDE_OUT_MODES.WORK_ORDER_DETAILS,
        workOrderCode,
        workOrderId: slideOutState.workOrderId,
      },
    });

  return {
    closeSlideOut,
    isFilterMode,
    isOpen,
    isWorkOrderMode,
    openFilterSidebar,
    openWorkOrderDetails,
    setWorkOrderCode,
    workOrderCode: slideOutState.workOrderCode,
    workOrderId: slideOutState.workOrderId,
  };
}
